export const industriesResources = {
    en: {
        IndustryExpertise: "Industry Expertise",
        Title: "Industries We Serve",
        Intro:
            "We bring deep finance expertise tailored to each industry's unique needs. From KPIs to regulatory complexities, our solutions streamline finance operations and deliver actionable insights.",

        Includes: "Key Focus Areas",
        Outcomes: "Benefits",

        Pharmaceuticals: {
            Id: "pharmaceuticals",
            Title: "Pharmaceuticals & Life Sciences",
            Overview:
                "We support pharmaceutical companies with finance processes that ensure compliance, efficiency, and strategic decision-making.",
            Services: [
                "R&D cost tracking and budgeting",
                "Regulatory reporting compliance",
                "Clinical trial financial management",
                "Supply chain cost optimization"
            ],
            Outcomes: [
                "Accurate clinical trial cost tracking",
                "Regulatory-compliant reporting",
                "Better R&D ROI insights",
                "Optimized operational efficiency"
            ]
        },

        Technology: {
            Id: "technology",
            Title: "Technology & SaaS",
            Overview:
                "We help tech companies optimize their financial operations, scale rapidly, and maintain clear visibility across all business functions.",
            Services: [
                "Subscription revenue recognition",
                "SaaS KPI dashboards",
                "Cash flow forecasting for growth",
                "Investment and capital allocation tracking"
            ],
            Outcomes: [
                "Improved revenue visibility",
                "Optimized cash management",
                "Data-driven scaling decisions",
                "Enhanced investor reporting"
            ]
        },

        Manufacturing: {
            Id: "manufacturing",
            Title: "Manufacturing",
            Overview:
                "We provide manufacturing companies with finance solutions that track production costs, manage budgets, and enhance operational efficiency.",
            Services: [
                "Cost of goods sold (COGS) analysis",
                "Production budget tracking",
                "Inventory and raw material finance control",
                "Operational efficiency reporting"
            ],
            Outcomes: [
                "Lower production costs",
                "Better inventory management",
                "Improved profitability per product line",
                "Data-driven production planning"
            ]
        },

        Retail: {
            Id: "retail",
            Title: "Retail & E-commerce",
            Overview:
                "We support retail businesses by aligning finance processes with sales, inventory, and customer metrics for actionable insights.",
            Services: [
                "Sales and margin tracking",
                "Inventory and supply chain finance",
                "Customer behavior financial analysis",
                "Multi-channel revenue reporting"
            ],
            Outcomes: [
                "Higher margin visibility",
                "Better inventory control",
                "Improved revenue per channel",
                "Actionable insights for merchandising"
            ]
        },

        Professional: {
            Id: "professional",
            Title: "Professional Services",
            Overview:
                "We help professional services firms optimize project-based financial workflows, billing, and resource allocation.",
            Services: [
                "Project profitability tracking",
                "Time & billing management",
                "Resource allocation and utilization reporting",
                "Client invoicing and revenue recognition"
            ],
            Outcomes: [
                "Improved project profitability",
                "Optimized billing cycles",
                "Better resource utilization",
                "Accurate client revenue reporting"
            ]
        },

        Healthcare: {
            Id: "healthcare",
            Title: "Healthcare",
            Overview:
                "We provide healthcare organizations with financial management tools that ensure regulatory compliance and operational efficiency.",
            Services: [
                "Patient billing & reimbursement workflows",
                "Healthcare regulatory compliance",
                "Cost per procedure analysis",
                "Operational financial efficiency reporting"
            ],
            Outcomes: [
                "Faster billing cycles",
                "Enhanced compliance",
                "Accurate cost per procedure tracking",
                "Optimized operational costs"
            ]
        }
    },

    ar: {
        IndustryExpertise: "الخبرة القطاعية",
        Title: "الصناعات التي نخدمها",
        Intro:
            "نقدم خبرة مالية عميقة مصممة لتلبية احتياجات كل صناعة. من مؤشرات الأداء إلى التعقيدات التنظيمية، حلولنا تبسط العمليات المالية وتوفر رؤى قابلة للتنفيذ.",

        Includes: "المجالات الرئيسية",
        Outcomes: "الفوائد",

        Pharmaceuticals: {
            Id: "pharmaceuticals",
            Title: "الأدوية وعلوم الحياة",
            Overview:
                "ندعم شركات الأدوية بعمليات مالية تضمن الامتثال والكفاءة واتخاذ القرارات الاستراتيجية.",
            Services: [
                "تتبع تكاليف البحث والتطوير والميزانية",
                "الامتثال للتقارير التنظيمية",
                "إدارة مالية للتجارب السريرية",
                "تحسين تكاليف سلسلة التوريد"
            ],
            Outcomes: [
                "تتبع دقيق لتكاليف التجارب السريرية",
                "تقارير متوافقة مع اللوائح",
                "رؤية أفضل لعائد الاستثمار في البحث والتطوير",
                "كفاءة تشغيلية محسنة"
            ]
        },

        Technology: {
            Id: "technology",
            Title: "التكنولوجيا و SaaS",
            Overview:
                "نساعد شركات التكنولوجيا على تحسين عملياتها المالية، والتوسع بسرعة، والحفاظ على رؤية واضحة عبر جميع وظائف الأعمال.",
            Services: [
                "الاعتراف بالإيرادات الاشتراكية",
                "لوحات مؤشرات أداء SaaS",
                "توقع التدفقات النقدية للنمو",
                "تتبع الاستثمارات وتخصيص رأس المال"
            ],
            Outcomes: [
                "رؤية أفضل للإيرادات",
                "إدارة نقدية محسّنة",
                "قرارات التوسع مدعومة بالبيانات",
                "تقارير محسنة للمستثمرين"
            ]
        },

        Manufacturing: {
            Id: "manufacturing",
            Title: "التصنيع",
            Overview:
                "نوفر لشركات التصنيع حلول مالية تتبع تكاليف الإنتاج، وتدير الميزانيات، وتعزز الكفاءة التشغيلية.",
            Services: [
                "تحليل تكلفة البضائع المباعة",
                "تتبع ميزانية الإنتاج",
                "التحكم المالي في المخزون والمواد الخام",
                "تقارير كفاءة التشغيل"
            ],
            Outcomes: [
                "خفض تكاليف الإنتاج",
                "تحسين إدارة المخزون",
                "زيادة الربحية لكل خط إنتاج",
                "تخطيط الإنتاج المبني على البيانات"
            ]
        },

        Retail: {
            Id: "retail",
            Title: "التجزئة والتجارة الإلكترونية",
            Overview:
                "ندعم شركات التجزئة بمحاذاة العمليات المالية مع المبيعات والمخزون وقياسات العملاء للحصول على رؤى قابلة للتنفيذ.",
            Services: [
                "تتبع المبيعات والهامش",
                "المالية المتعلقة بالمخزون وسلسلة التوريد",
                "تحليل مالي لسلوك العملاء",
                "تقارير الإيرادات متعددة القنوات"
            ],
            Outcomes: [
                "رؤية أفضل للهامش الربحي",
                "تحكم أفضل في المخزون",
                "زيادة الإيرادات لكل قناة",
                "رؤى قابلة للتنفيذ للمنتجات"
            ]
        },

        Professional: {
            Id: "professional",
            Title: "الخدمات المهنية",
            Overview:
                "نساعد شركات الخدمات المهنية على تحسين التدفقات المالية القائمة على المشاريع والفوترة وتخصيص الموارد.",
            Services: [
                "تتبع ربحية المشاريع",
                "إدارة الوقت والفوترة",
                "تخطيط الموارد واستخدامها",
                "الفوترة للعملاء والاعتراف بالإيرادات"
            ],
            Outcomes: [
                "تحسين ربحية المشاريع",
                "دورات فوترة محسنة",
                "استخدام أفضل للموارد",
                "تقارير دقيقة لإيرادات العملاء"
            ]
        },

        Healthcare: {
            Id: "healthcare",
            Title: "الرعاية الصحية",
            Overview:
                "نوفر للمؤسسات الصحية أدوات إدارة مالية تضمن الامتثال التنظيمي والكفاءة التشغيلية.",
            Services: [
                "عمليات الفوترة والتعويض للمرضى",
                "الامتثال للوائح الرعاية الصحية",
                "تحليل التكلفة لكل إجراء",
                "تقارير كفاءة العمليات المالية"
            ],
            Outcomes: [
                "تسريع دورات الفوترة",
                "تعزيز الامتثال",
                "تتبع دقيق لتكلفة كل إجراء",
                "تحسين التكاليف التشغيلية"
            ]
        }
    }
};
